export const defaultLanguage = "vi";

const languages = {
  en: {
    "Chỉ đường đến Sự kiện": "Direct to event",
    "Quay lại": "Back",
    "Ưu đãi nổi bật": "Hot promotion",
    "Phố ẩm thực": "Foodcoast",
    "Được yêu thích": "Best choice",
    "Nên thử": "Must-try",
    "Thực đơn": "Menu",
    "Ưu đãi hấp dẫn": "Hot Promotion",
    "Bạn đang ở đây": "You are here",
    "Vị trí của bạn": "Your position",
    "Sự kiện nổi bật": "Special event",
    "Chỉ đường đến gian hàng": "Direct to tenant",
    "Không có kết quả phù hợp": "No tenants found",
    "Bụi mịn": "PM 2.5",
    "Độ tinh khiết": "Purity",
    "Lưu lượng trao đổi khí": "Ventilation",
    "Rất tốt": "Very Good",
    Tốt: "Good",
    "Bình thường": "Normal",
    "Không tốt": "Bad",
    "Không có promotion": "No promotions found",
    "Không có event": "No events found",
    "Tìm Kiếm": "Search",
    "Dấu cách": "Space",
    "Nhập tên gian hàng bạn muốn tìm kiếm ...":
      "Enter the name of the store you want to search ...",
    "ôi không": "oh no !!!",
    "Kết nối mạng đang gặp vấn đề.Vui lòng thử lại sau":
      "The network connection was lost. Please try again later.",
    phút: "minute(s)",
    "thử lại": "reload",
    "trong tttm": "in building",
    "ngoài tttm": "city",
    title1:
      "Stores participate in WAON Membership Program – have a WAON POINT symbol on the logo",
  },
  vi: {
    "Chỉ đường đến Sự kiện": "Chỉ đường đến Sự kiện",
    "Quay lại": "Quay lại",
    "Ưu đãi nổi bật": "Ưu đãi nổi bật",
    "Phố ẩm thực": "Phố ẩm thực",
    "Được yêu thích": "Được yêu thích",
    "Nên thử": "Nên thử",
    "Thực đơn": "Thực đơn",
    "Ưu đãi hấp dẫn": "Ưu đãi hấp dẫn",
    "Bạn đang ở đây": "Bạn đang ở đây",
    "Vị trí của bạn": "Vị trí của bạn",
    "Sự kiện nổi bật": "Sự kiện nổi bật",
    "Chỉ đường đến gian hàng": "Chỉ đường đến gian hàng",
    "Không có kết quả phù hợp": "Không có kết quả phù hợp",
    "Bụi mịn": "Bụi mịn PM 2.5",
    "Độ tinh khiết": "Độ tinh khiết",
    "Lưu lượng trao đổi khí": "Lưu lượng trao đổi khí",
    "Rất tốt": "Rất tốt",
    Tốt: "Tốt",
    "Bình thường": "Bình thường",
    "Không tốt": "Không tốt",
    "Không có promotion": "Không có kết quả phù hợp",
    "Không có event": "Không có kết quả phù hợp",
    "Tìm Kiếm": "Tìm Kiếm",
    "Dấu cách": "Dấu cách",
    "Nhập tên gian hàng bạn muốn tìm kiếm ...":
      "Nhập tên gian hàng bạn muốn tìm kiếm ...",
    "ôi không": "ôi không !!!",
    "Kết nối mạng đang gặp vấn đề.Vui lòng thử lại sau":
      "Kết nối mạng đang gặp vấn đề. Vui lòng thử lại sau.",
    phút: "phút",
    "thử lại": "thử lại",
    "trong tttm": "trong tttm",
    "ngoài tttm": "ngoài tttm",
    title1:
      "Các gian hàng tham gia Chương trình điểm thành viên WAON – WAON POINT có biểu tượng WAON POINT trên logo",
  },
};

export default languages;
